import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "../styles/analytics-consent.css";

export default function AnalyticsConsent() {
  const [snapshot, setSnapshot] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const update = () => setSnapshot(window.symAnalyticsConsent?.getSnapshot() || null);
    update();
    window.addEventListener("sym:consent-change", update);
    return () => window.removeEventListener("sym:consent-change", update);
  }, []);

  const choose = (choice) => {
    if (window.symAnalyticsConsent?.setPreference(choice)) setOpen(false);
  };
  const needsChoice = snapshot?.requiresConsent && !snapshot.choice;
  const actions = (
    <div className="d-flex flex-wrap gap-2">
      <button type="button" className="btn btn-primary" onClick={() => choose("granted")}>Accept analytics</button>
      <button type="button" className="btn btn-outline-secondary" onClick={() => choose("denied")}>
        {snapshot?.allowed ? "Withdraw analytics consent" : "Reject analytics"}
      </button>
    </div>
  );
  const description = (
    <p>
      We use optional Google Analytics cookies to understand website use and approximate country.
      Advertising storage and personalization are always off. You can accept, reject, or withdraw
      analytics at any time. The website works regardless of your choice. Preferences last 180 days
      on this browser and apply even when you travel. <a href="/privacy">Privacy Policy</a>
    </p>
  );

  return (
    <div data-analytics-consent-ui className="d-print-none">
      <footer className="text-center py-3">
        <button type="button" className="btn btn-link" onClick={() => setOpen(true)}>
          Privacy/Cookie Settings
        </button>
      </footer>
      {needsChoice && !open && (
        <section
          className="analytics-consent-notice"
          aria-labelledby="analytics-consent-notice-title"
        >
          <h2 id="analytics-consent-notice-title" className="h6">Optional analytics cookies</h2>
          <p>
            Allow Google Analytics to measure website use? Advertising personalization is always off.{" "}
            <a href="/privacy">Privacy Policy</a>
          </p>
          {snapshot.error && <p role="alert">{snapshot.error}</p>}
          <div className="analytics-consent-actions">
            <button type="button" className="btn btn-primary" onClick={() => choose("granted")}>
              Accept analytics
            </button>
            <button type="button" className="btn btn-outline-secondary" onClick={() => choose("denied")}>
              Reject analytics
            </button>
          </div>
        </section>
      )}
      {!needsChoice && snapshot?.error && <p className="container" role="alert">{snapshot.error}</p>}
      <Modal show={open} onHide={() => setOpen(false)} aria-labelledby="analytics-settings-title" centered>
        <Modal.Header closeButton>
          <Modal.Title id="analytics-settings-title">Privacy/Cookie Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {description}
          <p>Analytics is currently {snapshot?.allowed ? "on" : "off"}.</p>
          {snapshot?.error && <p role="alert">{snapshot.error}</p>}
          {!snapshot && <p role="alert">Analytics settings are unavailable. Optional tracking is off. Please reload to try again.</p>}
          {snapshot && actions}
        </Modal.Body>
      </Modal>
    </div>
  );
}
